'use client';

import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { easeOut, motion } from 'framer-motion';
import React, { PropsWithChildren } from 'react';
import { cn } from '~/lib/cn';
import Highlighter from '../../AnimatedComponents/Highlighter';
import { Button } from '../../Button';

interface Props {
    className?: string;
}

const containerVariants = {
    hidden: { opacity: 0, y: 24 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5,
            ease: easeOut
        }
    }
};

export const ContactSection: React.FC<PropsWithChildren<Props>> = ({ className }) => {
    return (
        <section className={cn(className)}>
            <motion.div
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.1, once: true }}
                className="tw-relative tw-flex tw-items-stretch"
            >
                <div className={cn('tw-card-bordered tw-relative tw-w-full tw-overflow-hidden')}>
                    <div className="tw-absolute tw-inset-y-0 tw-left-0 tw-w-1 tw-bg-success/70" />

                    <div className="tw-relative tw-px-6 tw-py-2 md:tw-px-10">
                        <p className="tw-text-md tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-success">
                            Noch offene Fragen?
                        </p>
                        <h3 className="tw-m-0 tw-font-bold tw-text-accents-9 md:tw-text-3xl">
                            <Highlighter iterations={2} variant="successLight">
                                Dann kontaktiere uns!
                            </Highlighter>
                        </h3>
                        <p className="tw-m-0 tw-mt-1 tw-text-sm tw-leading-relaxed tw-text-accents-7">
                            Tritt jetzt persönlich mit uns in Kontakt und erfahre noch mehr über die Möglichkeiten der
                            Sportision Platzbuchungen und wie du mithilfe von Sportision deine Umsätze steigern kannst.
                        </p>
                        <div className="tw-flex tw-flex-wrap tw-gap-2 tw-pt-2">
                            <Button.Link className="tw-mt-3 tw-w-fit" size="sm" href="tel:029228751440">
                                <FontAwesomeIcon icon={faPhone} /> Kontakt aufnehmen
                            </Button.Link>

                            <Button.Link size="sm" flat href="mailto:sales@sportision.de" className="tw-mt-3">
                                <FontAwesomeIcon icon={faEnvelope} /> E-Mail
                            </Button.Link>
                        </div>
                    </div>
                </div>
            </motion.div>
        </section>
    );
};
